/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Deva Sen. & Warren Dowey
 */

import { ApiFilterModel } from '@app/models/api-filter.model';
import { ApiSortModel } from '@app/models/api-sort.model';

export class ApiParamsModel {
  filter?: ApiFilterModel[];
  sort?: ApiSortModel[];
  select?: string[];
  limit?: number[];
  add?: AddParams;
}

export class AddParams {
  field?: string | string[];
  value?: string | string[];
}
